import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Matches from "../components/Matches";
import * as projectActions from "./../../../../../actions/project.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as tableActions from "./../../../../../actions/table.actions";
import * as userActions from "./../../../../../actions/user.actions";

const subHeader = {
  items: [
    {
      caption: "Matches",
      url: "/member/projects/matches"
    },
    {
      caption: "Pitches",
      url: "/member/projects/pitches"
    },
    {
      caption: "SOWs",
      url: "/member/projects/sows"
    },
    {
      caption: "Completed",
      url: "/member/projects/completed"
    },
    {
      caption: "Invoices",
      url: "/member/projects/invoices"
    }
  ],
  activeItem: 0,
  track: true
};

class MatchesContainer extends Component {
  constructor(props) {
    super(props);

    props.projectActions.getMatches();

    this.setTableOverlay = this.setTableOverlay.bind(this);
    this.removeTableOverlay = this.removeTableOverlay.bind(this);
    this.rejectMatch = this.rejectMatch.bind(this);
    this.undoRejection = this.undoRejection.bind(this);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(subHeader);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  setTableOverlay(position) {
    this.props.tableActions.setTableRowOverlayPosition({
      table: "MatchesTable",
      overlayPosition: position
    });
  }

  removeTableOverlay() {
    this.props.tableActions.setTableRowOverlayPosition({
      table: "MatchesTable",
      overlayPosition: null
    });
  }

  rejectMatch(matchId) {
    const payload = {
      match_id: matchId,
      declined: true
    };

    this.props.projectActions.declineMatch(payload);
  }

  undoRejection(matchId) {
    const payload = {
      match_id: matchId,
      declined: false
    };

    this.props.projectActions.declineMatch(payload);
  }

  render() {
    return (
      <Matches
        matches={this.props.project.matches}
        setTableOverlay={this.setTableOverlay}
        removeTableOverlay={this.removeTableOverlay}
        rejectMatch={this.rejectMatch}
        undoRejection={this.undoRejection}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    table: state.table
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    tableActions: bindActionCreators(tableActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MatchesContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/containers/MatchesContainer.js